import SubcategoryPage from '@/components/template/SubcategoryPage';

const TicTac = () => {
  const products = [
    {
      title: "TicTac Model 1",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/tictac/model-1"
    },
    {
      title: "TicTac Model 2",
      imageSrc: "https://images.unsplash.com/photo-1616627052149-fe43712e633e?auto=format&fit=crop&q=80",
      url: "/ogledala/tictac/model-2"
    },
    {
      title: "TicTac Model 3",
      imageSrc: "https://images.unsplash.com/photo-1554302891-c04b1941b963?auto=format&fit=crop&q=80",
      url: "/ogledala/tictac/model-3"
    },
    {
      title: "TicTac Model 4",
      imageSrc: "https://images.unsplash.com/photo-1603204077587-a3e570be71a9?auto=format&fit=crop&q=80",
      url: "/ogledala/tictac/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="TicTac"
      description="Igrivo zasnovana ogledala z ritmičnim vzorcem, ki dodajo dinamiko vašemu prostoru. Sodobno oblikovanje za tiste, ki cenijo drzne detajle."
      heroImage="https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TicTac;